import { UnknownError } from '@cian/peperrors';

import { assertions } from './assertions';
import { TChatType } from '../../../repositories/chats/entities/create_custom_chat/V1CustomChatSendMessageRequestSchema';
import { fetchCustomChatCreateChat } from '../../../repositories/chats/v1/custom-chat/create-chat';
import { showAlert } from '../../../slices/alertSlice';
import { ICustomChatParams } from '../../../types/customChatParams';
import { TThunkAction } from '../../../types/redux/thunk';
import { ETelemetryEvents } from '../../../types/telemetry';
import { getCustomChatContext } from '../../../utils/customChat';
import { setFirstMessageFailed, setFirstMessagePending } from '../actions';
import { DEFAULT_ERROR_MESSAGE } from '../constants';
import { mappers } from '../mappers';
import { TFirstMessageResponse } from '../types';
import { getDomainBySource, getTelemetryBySource } from '../utils';

interface ISendFirstMessageCustomChatProps {
  /** Токен капчи(для проверки валидности, только desktop) **/
  captchaToken?: string;
  /** Параметры чата по кастомной сущности. **/
  customChatParams: ICustomChatParams;
  /** Текст сообщения **/
  text: string;
}

const SOURCE = 'customChat';

/**
 * @description
 * Отправка первого сообщения в кастомный чат
 */
export const sendFirstMessageCustomChat =
  ({ customChatParams, text, captchaToken }: ISendFirstMessageCustomChatProps): TThunkAction<Promise<void>> =>
  async (dispatch, _, { httpApi, telemetry, logger }) => {
    dispatch(setFirstMessagePending());

    const customChatTelemetry = getTelemetryBySource(telemetry, SOURCE);

    const domain = getDomainBySource(SOURCE);

    customChatTelemetry.increment(ETelemetryEvents.ChatFirstMessageSendInit);

    const startTime = Date.now();

    try {
      const response = (await fetchCustomChatCreateChat({
        httpApi,
        parameters: {
          entityId: customChatParams.entityId,
          chatType: customChatParams.entityType as TChatType,
          receiverUserId: customChatParams.receiverUserId,
          context: getCustomChatContext(customChatParams.context, logger),
          text,
          captchaToken,
        },
        mappers,
      })) as TFirstMessageResponse;

      assertions.forEach(assertion => {
        dispatch(
          assertion(response, {
            text,
            startTime,
            domain,
            telemetry: customChatTelemetry,
          }),
        );
      });
    } catch (error) {
      customChatTelemetry.increment(ETelemetryEvents.ChatFirstMessageSendUnknownError);

      const unknownError = new UnknownError({
        message: DEFAULT_ERROR_MESSAGE,
        domain,
        details: error,
      });

      logger.error(unknownError);

      dispatch(setFirstMessageFailed());
      dispatch(showAlert({}));
    }
  };
